export const FAQ_VIEW = (slug) => `/platform/content/faq/${slug}`;
export const FAQ_LIST = '/platform/content/faq';
export const FAQ_QUESTION_LIST = '/platform/content/faq-question-list';
export const FAQ_SEARCH = '/platform/content/faq/search';
